import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const PaymentHistoryTab = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [filterStatus, setFilterStatus] = useState('all');

  const transactions = [
    {
      id: 'INV-2026-001',
      date: '2026-02-08',
      amount: 2999,
      status: 'success',
      method: 'Visa •••• 4242',
      description: 'Growth Plan - Monthly Subscription'
    },
    {
      id: 'INV-2026-002',
      date: '2026-01-08',
      amount: 2999,
      status: 'success',
      method: 'Visa •••• 4242',
      description: 'Growth Plan - Monthly Subscription'
    },
    {
      id: 'INV-2025-012',
      date: '2025-12-08',
      amount: 2999,
      status: 'success',
      method: 'Visa •••• 4242',
      description: 'Growth Plan - Monthly Subscription'
    },
    {
      id: 'INV-2025-011',
      date: '2025-11-08',
      amount: 2999,
      status: 'failed',
      method: 'Visa •••• 4242',
      description: 'Growth Plan - Monthly Subscription'
    },
    {
      id: 'INV-2025-010',
      date: '2025-10-08',
      amount: 2999,
      status: 'success',
      method: 'Visa •••• 4242',
      description: 'Growth Plan - Monthly Subscription'
    }
  ];

  const getStatusStyles = (status) => {
    if (status === 'success') {
      return {
        bg: 'bg-success/10',
        text: 'text-success',
        border: 'border-success/20',
        icon: 'CheckCircle'
      };
    }
    if (status === 'failed') {
      return {
        bg: 'bg-error/10',
        text: 'text-error',
        border: 'border-error/20',
        icon: 'XCircle'
      };
    }
    return {
      bg: 'bg-warning/10',
      text: 'text-warning',
      border: 'border-warning/20',
      icon: 'Clock'
    };
  };

  const filteredTransactions = transactions?.filter((transaction) => {
    const matchesSearch = transaction?.id?.toLowerCase()?.includes(searchQuery?.toLowerCase()) ||
                         transaction?.description?.toLowerCase()?.includes(searchQuery?.toLowerCase());
    const matchesFilter = filterStatus === 'all' || transaction?.status === filterStatus;
    return matchesSearch && matchesFilter;
  });

  const handleDownloadInvoice = (invoiceId) => {
    console.log('Downloading invoice:', invoiceId);
  };

  return (
    <div className="space-y-6">
      {/* Search and Filters */}
      <div className="bg-card border border-border rounded-lg p-4 elevation-sm">
        <div className="flex flex-col gap-4">
          <div className="flex-1 relative">
            <Icon 
              name="Search" 
              size={18} 
              color="var(--color-muted-foreground)" 
              className="absolute left-3 top-1/2 -translate-y-1/2"
            />
            <input
              type="text"
              placeholder="Search by invoice number or description..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e?.target?.value)}
              className="w-full pl-10 pr-4 py-2 bg-background border border-border rounded-md text-sm text-foreground font-body placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary/50"
            />
          </div>
          <div className="flex flex-wrap gap-2">
            {['all', 'success', 'failed']?.map((status) => (
              <button
                key={status}
                onClick={() => setFilterStatus(status)}
                className={`px-4 py-2 rounded-md text-sm font-medium font-caption transition-smooth ${
                  filterStatus === status
                    ? 'bg-primary text-primary-foreground'
                    : 'bg-muted text-muted-foreground hover:bg-muted/80'
                }`}
              >
                {status?.charAt(0)?.toUpperCase() + status?.slice(1)}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* Transaction Summary */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="bg-card border border-border rounded-lg p-4 elevation-sm">
          <div className="flex items-center gap-3 mb-3">
            <div className="w-10 h-10 rounded-lg bg-success/10 flex items-center justify-center">
              <Icon name="TrendingUp" size={18} color="var(--color-success)" />
            </div>
            <h4 className="text-sm font-medium text-muted-foreground font-caption">
              Total Paid
            </h4>
          </div>
          <p className="text-2xl font-bold text-foreground font-heading">
            ₹{(transactions?.filter(t => t?.status === 'success')?.reduce((sum, t) => sum + t?.amount, 0))?.toLocaleString()}
          </p>
        </div>
        <div className="bg-card border border-border rounded-lg p-4 elevation-sm">
          <div className="flex items-center gap-3 mb-3">
            <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
              <Icon name="Receipt" size={18} color="var(--color-primary)" />
            </div>
            <h4 className="text-sm font-medium text-muted-foreground font-caption">
              Total Invoices
            </h4>
          </div>
          <p className="text-2xl font-bold text-foreground font-heading">
            {transactions?.length}
          </p>
        </div>
        <div className="bg-card border border-border rounded-lg p-4 elevation-sm">
          <div className="flex items-center gap-3 mb-3">
            <div className="w-10 h-10 rounded-lg bg-error/10 flex items-center justify-center">
              <Icon name="AlertCircle" size={18} color="var(--color-error)" />
            </div>
            <h4 className="text-sm font-medium text-muted-foreground font-caption">
              Failed Payments
            </h4>
          </div>
          <p className="text-2xl font-bold text-foreground font-heading">
            {transactions?.filter(t => t?.status === 'failed')?.length}
          </p>
        </div>
      </div>

      {/* Transaction List */}
      <div className="bg-card border border-border rounded-lg elevation-sm overflow-hidden">
        {/* Desktop Table View */}
        <div className="hidden lg:block overflow-x-auto">
          <table className="w-full">
            <thead className="bg-muted/50 border-b border-border">
              <tr>
                <th className="text-left px-6 py-3 text-xs font-semibold text-muted-foreground font-caption uppercase tracking-wider">
                  Invoice
                </th>
                <th className="text-left px-6 py-3 text-xs font-semibold text-muted-foreground font-caption uppercase tracking-wider">
                  Date
                </th>
                <th className="text-left px-6 py-3 text-xs font-semibold text-muted-foreground font-caption uppercase tracking-wider">
                  Description
                </th>
                <th className="text-left px-6 py-3 text-xs font-semibold text-muted-foreground font-caption uppercase tracking-wider">
                  Amount
                </th>
                <th className="text-left px-6 py-3 text-xs font-semibold text-muted-foreground font-caption uppercase tracking-wider">
                  Method
                </th>
                <th className="text-left px-6 py-3 text-xs font-semibold text-muted-foreground font-caption uppercase tracking-wider">
                  Status
                </th>
                <th className="text-left px-6 py-3 text-xs font-semibold text-muted-foreground font-caption uppercase tracking-wider">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-border">
              {filteredTransactions?.map((transaction) => {
                const statusStyles = getStatusStyles(transaction?.status);
                return (
                  <tr key={transaction?.id} className="hover:bg-muted/30 transition-smooth">
                    <td className="px-6 py-4">
                      <span className="text-sm font-medium text-foreground font-body">
                        {transaction?.id}
                      </span>
                    </td>
                    <td className="px-6 py-4">
                      <span className="text-sm text-muted-foreground font-caption">
                        {new Date(transaction?.date)?.toLocaleDateString('en-IN', { 
                          day: 'numeric', 
                          month: 'short', 
                          year: 'numeric' 
                        })}
                      </span>
                    </td>
                    <td className="px-6 py-4">
                      <span className="text-sm text-foreground font-body">
                        {transaction?.description}
                      </span>
                    </td>
                    <td className="px-6 py-4">
                      <span className="text-sm font-semibold text-foreground font-body">
                        ₹{transaction?.amount?.toLocaleString()}
                      </span>
                    </td>
                    <td className="px-6 py-4">
                      <span className="text-sm text-muted-foreground font-caption">
                        {transaction?.method}
                      </span>
                    </td>
                    <td className="px-6 py-4">
                      <div className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md ${statusStyles?.bg} border ${statusStyles?.border}`}>
                        <Icon name={statusStyles?.icon} size={12} color={`var(--color-${transaction?.status === 'success' ? 'success' : transaction?.status === 'failed' ? 'error' : 'warning'})`} />
                        <span className={`text-xs font-medium font-caption ${statusStyles?.text}`}>
                          {transaction?.status?.charAt(0)?.toUpperCase() + transaction?.status?.slice(1)}
                        </span>
                      </div>
                    </td>
                    <td className="px-6 py-4">
                      <Button
                        variant="ghost"
                        size="sm"
                        iconName="Download"
                        iconPosition="left"
                        onClick={() => handleDownloadInvoice(transaction?.id)}
                      >
                        Invoice
                      </Button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>

        {/* Mobile Card View */}
        <div className="lg:hidden divide-y divide-border">
          {filteredTransactions?.map((transaction) => {
            const statusStyles = getStatusStyles(transaction?.status);
            return (
              <div key={transaction?.id} className="p-4 space-y-3">
                <div className="flex items-start justify-between gap-2">
                  <div className="flex-1">
                    <p className="text-sm font-medium text-foreground font-body mb-1">
                      {transaction?.id}
                    </p>
                    <p className="text-xs text-muted-foreground font-caption">
                      {new Date(transaction?.date)?.toLocaleDateString('en-IN', { 
                        day: 'numeric', 
                        month: 'short', 
                        year: 'numeric' 
                      })}
                    </p>
                  </div>
                  <div className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md ${statusStyles?.bg} border ${statusStyles?.border}`}>
                    <Icon name={statusStyles?.icon} size={12} color={`var(--color-${transaction?.status === 'success' ? 'success' : transaction?.status === 'failed' ? 'error' : 'warning'})`} />
                    <span className={`text-xs font-medium font-caption ${statusStyles?.text}`}>
                      {transaction?.status?.charAt(0)?.toUpperCase() + transaction?.status?.slice(1)}
                    </span>
                  </div>
                </div>
                <div>
                  <p className="text-sm text-foreground font-body mb-1">
                    {transaction?.description}
                  </p>
                  <p className="text-xs text-muted-foreground font-caption">
                    {transaction?.method}
                  </p>
                </div>
                <div className="flex items-center justify-between pt-2">
                  <span className="text-base font-semibold text-foreground font-body">
                    ₹{transaction?.amount?.toLocaleString()}
                  </span>
                  <Button
                    variant="ghost"
                    size="sm"
                    iconName="Download"
                    iconPosition="left"
                    onClick={() => handleDownloadInvoice(transaction?.id)}
                  >
                    Invoice
                  </Button>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default PaymentHistoryTab;